import { render, staticRenderFns } from "./SchoolTerm.vue?vue&type=template&id=370e881b&"
import script from "./SchoolTerm.vue?vue&type=script&lang=ts&"
export * from "./SchoolTerm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports